/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

// $('#product-builder').css('height','auto !important');
  window.onload = function () {
    document.getElementById("product-builder").style.height = 'auto';
  }

  if($(window).width() < 768){
  $('#product_gallery').slick({
    slidesToShow: 1,
    dots: true
  });
  //   $('#product_gallery_thumbs').slick({
  //     slidesToShow: 5,
  //     dots: false,
  //     asNavFor: '#product_gallery'
  //   });
  //   $('#product_gallery').lightSlider({
  //   item: 1,
  //   asNavFor: "#product_gallery_thumbs"
  // });
  //   $('#product_gallery_thumbs').lightSlider({
  //     item: 5,
  //     dots: false,
  //     asNavFor: '#product_gallery'
  //   });
    
    }


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
